import { UserRole } from 'context/auth/types'

export type RoleLevel = 1 | 2 | 3 | 4 | 5 | 'noOwner'

export const ROLE_LEVEL: Record<RoleLevel, UserRole[]> = {
	1: ['OWNER'],
	2: ['OWNER', 'ADMIN'],
	3: ['OWNER', 'ADMIN', 'EDITOR'],
	4: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER'],
	5: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER', 'STAFF'],
	noOwner: ['ADMIN', 'EDITOR', 'VIEWER', 'STAFF'],
}
